import { render, staticRenderFns } from "./DeliveryAdviceCostChargeForm.vue?vue&type=template&id=0139fb55"
import script from "./DeliveryAdviceCostChargeForm.vue?vue&type=script&lang=js"
export * from "./DeliveryAdviceCostChargeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports